<div class="verification-data-selection-form">
  <div class="verification-data-selection-form__vd-dropdown">
    <label for="verification-data-selection-form__vd-dropdown" class="vox-label" translate>
      company.did.verification-data-selection-form.selection.label</label>
    <div ngbDropdown class="vox-dropdown-input">
      <button class="verification-data-selection-form__vd-dropdown_btn" id="verification-data-selection-form__vd-dropdown"
        ngbDropdownToggle>
        <span *ngIf="selectedOption.type === OPTION_TYPE.NEW" translate>
          common.create-new
        </span>
        <span *ngIf="selectedOption.type === OPTION_TYPE.NONE" translate>
          company.did.verification-data-selection-form.selection.options.nope
        </span>
        <span *ngIf="selectedOption.type === OPTION_TYPE.CLONE" class="vd-dropdown_did-item">
          <span class="vd-dropdown_did-item_label" translate>company.did.verification-data-selection-form.selection.use</span>
          <span class="vd-dropdown_did-item_flag flag flag-icon" [ngClass]="['flag-icon-' + selectedOption.did.country.toLowerCase()]"></span>
          <span class="vd-dropdown_did-item_number">{{selectedOption.did.number}}</span>
          <span class="vd-dropdown_did-item_class vox-chip vox-chip_dark-grey">{{selectedOption.did.did_class | didClass}}</span>
          <span class="vd-dropdown_did-item_type vox-chip vox-chip_royal-blue-text">{{selectedOption.did.did_type | didType}}</span>
          <span *ngIf="selectedOption.did.status === DID_STATUS.ACTIVE" class="vd-dropdown_did-item_icon">
            <i class="icon-small-check-circle" [ngbTooltip]="'company.did.verification-data-selection-form.selection.tooltip'| translate"></i>
          </span>
        </span>
      </button>
      <div class="verification-data-selection-form__vd-dropdown_menu" ngbDropdownMenu
        aria-labelledby="verification-data-selection-form__vd-dropdown">
        <button ngbDropdownItem class="verification-data-selection-form__vd-dropdown_item--new"
        type="button" (click)="onSelectDid(OPTION_TYPE.NEW, null)" translate>
          common.create-new
        </button>
        <button *ngIf="allowNoVD" ngbDropdownItem class="verification-data-selection-form__vd-dropdown_item"
        type="button" (click)="onSelectDid(OPTION_TYPE.NONE, null)" translate>
        company.did.verification-data-selection-form.selection.options.nope
        </button>
        <button *ngIf="dids.length !== 0" ngbDropdownItem class="verification-data-selection-form__vd-dropdown_item--use" type="button" translate>
          company.did.verification-data-selection-form.selection.options.use
        </button>
        <button ngbDropdownItem class="verification-data-selection-form__vd-dropdown_item--did"
        *ngFor="let did of dids" (click)="onSelectDid(OPTION_TYPE.CLONE, did)" type="button" translate>
          <span class="vd-dropdown_did-item">
            <span class="vd-dropdown_did-item_flag flag flag-icon" [ngClass]="['flag-icon-' + did.country.toLowerCase()]"></span>
            <span class="vd-dropdown_did-item_number">{{did.number}}</span>
            <span class="vd-dropdown_did-item_class vox-chip vox-chip_dark-grey">{{did.did_class | didClass}}</span>
            <span class="vd-dropdown_did-item_type vox-chip vox-chip_royal-blue-text">{{did.did_type | didType}}</span>
            <span *ngIf="did.status === DID_STATUS.ACTIVE" class="vd-dropdown_did-item_icon">
              <i class="icon-small-check-circle" [ngbTooltip]="'company.did.verification-data-selection-form.selection.tooltip'| translate"></i>
            </span>
          </span>
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="showVDDataErrorMessage" class="vox-inline-message vox-inline-message_light-grey mt-3">
    <div>
      <i class="icon-small-alert"></i>
      <span>
        <span class="vox-inline-message__message" translate>company.did.verification-data-selection-form.selection.error.disclaimer</span>
        <a class="vox-inline-message__link" (click)="getVerificationData(selectedOption.did)" translate>company.did.verification-data-selection-form.selection.error.link</a>
      </span>
    </div>
  </div>
  <div *ngIf="selectedOption.type === OPTION_TYPE.NEW" class="verification-data-selection-form__vd-form">
    <gdp-verfication-data-form
    [country]="country"
    [loading]="loading"
    [language]="language"
    [requirements]="requirements"
    (onValueChanged)="onVerificationDataChange($event)">
    </gdp-verfication-data-form>
  </div>
  <div *ngIf="selectedOption.type === OPTION_TYPE.CLONE" class="verification-data-selection-form__vd-table">
    <vox-vd-table-readonly
    *ngIf="!showVDDataErrorMessage"
    [data]="verificationData"
    [language]="language"
    [loading]="loading"
    [vertical]="isVerticalVDTable">
    </vox-vd-table-readonly>
  </div>
</div>